import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ContractsAPI(): BringozApi {
  return {
    base: `/priceplansBundle/contract`,
    infiniteScroll: {
      address: `/priceplansBundle/contract`,
      cmd: 'GET'
    },
    actions: {
      createContract: {
        address: '',
        cmd: 'PUT',
        updateable: false,
      },
      updateContract: {
        address: '{id}/updateName',
        cmd: 'POST',
        updateable: false,
      },
      deleteContract: {
        address: '{id}',
        updateable: false,
        cmd: 'DELETE'
      },
      addAccounts: {
        address: '{id}/addAccounts',
        updateable: false,
        cmd: 'POST'
      },
      removeAccounts: {
        address: '{id}/removeAccounts',
        updateable: false,
        cmd: 'POST'
      },
      addNewProgramToContract: {
        address: '{id}/activeProgram',
        updateable: false,
        cmd: 'POST'
      },
      removeProgramFromContract: {
        address: '{id}/inactiveProgram',
        updateable: false,
        cmd: 'POST'
      },
      setAsDefault: {
        address: '{id}/default',
        updateable: false,
        cmd: 'POST'
      },
    }
  }
}

angular
  .module('bringoz.admin.contracts')
  .factory('ContractsAPI', ContractsAPI);
